import React from 'react';
import { Box, Typography, Container, useTheme } from '@mui/material';

const Footer = () => {
  const theme = useTheme();

  // Check if the theme mode is dark
  const isDarkMode = theme.palette.mode === 'dark';

  return (
    <Box
      component="footer"
      sx={{
        // Use different background and text colors based on the theme mode
        bgcolor: isDarkMode ? theme.palette.grey[800] : theme.palette.grey[100],
        py: 2,
        color: isDarkMode ? theme.palette.grey[400] : theme.palette.grey[500],
      }}
    >
      <Container maxWidth="lg" sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="caption" align="left">
          Providing key insights into the Software Engineering process.
        </Typography>
        <Typography variant="caption" align="right">
          DevInsights 2025
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;

